import React, { useMemo } from "react";
import styled from "styled-components";
import { sanitizeRichTextHtml, plainTextToRichText } from "../../utils/richText";

const ViewWrapper = styled.div`
  color: inherit;
  font-size: inherit;
  line-height: 1.55;
  word-break: break-word;

  p {
    margin: 0 0 0.5rem;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul,
  ol {
    margin: 0 0 0.5rem;
    padding-left: 1.4rem;
  }

  a {
    color: #dbfb8e;
  }
`;

export default function RichTextView({ value, fallback = "—", ...rest }) {
  const html = useMemo(() => sanitizeRichTextHtml(plainTextToRichText(value)), [value]);

  if (!html) return <>{fallback}</>;

  return <ViewWrapper {...rest} dangerouslySetInnerHTML={{ __html: html }} />;
}
